module.exports = __webpack_public_path__ + "img/tgglow.6bbc61aa.png";